import { useEffect } from "react";

/**
 * iOS Safari paints the keyboard / chrome gap with theme-color.
 * Checklist fill (and most dashboard pages) stay on a white canvas even when
 * the dashboard chrome theme is dark — a dark theme-color restores the
 * near-black stripe this fix removes. Always pin to white.
 */
export const THEME_COLOR_IOS = "#ffffff";
/** @deprecated Use THEME_COLOR_IOS — dark meta color reintroduces the keyboard bar. */
export const THEME_COLOR_LIGHT = THEME_COLOR_IOS;
/** @deprecated Not used for meta — kept so old imports do not crash. */
export const THEME_COLOR_DARK = THEME_COLOR_IOS;

export const APPLE_STATUS_BAR_STYLE = "default";

export function themeColorFor(_theme) {
  return THEME_COLOR_IOS;
}

function ensureMeta(name) {
  let meta = document.querySelector(`meta[name="${name}"]`);
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute("name", name);
    document.head.appendChild(meta);
  }
  return meta;
}

export function applyThemeColorMeta(_theme) {
  if (typeof document === "undefined") return;
  ensureMeta("theme-color").setAttribute("content", THEME_COLOR_IOS);
  // Black-translucent + dark theme-color also paints the keyboard gap black.
  ensureMeta("apple-mobile-web-app-status-bar-style").setAttribute(
    "content",
    APPLE_STATUS_BAR_STYLE
  );
}

export function useThemeColorMeta(theme) {
  useEffect(() => {
    applyThemeColorMeta(theme);
  }, [theme]);
}
